import { EnumToArrayValues } from '@vestico/utils';

import { BraSupportAnswer, ComfortAnswer, FitAnswer, FitLikeAnswer, LengthAnswer, ReturningAnswer, SizeAnswer, SkinConcernAnswer } from './answer';
import {
  DefaultQuestionUID,
  DynamicSelectQuestion,
  MultiOptionQuestion,
  Question,
  QuestionDataSourceType,
  QuestionType,
  TextQuestion,
} from './question';

export const FitQuestion: MultiOptionQuestion = {
  uid: DefaultQuestionUID.fit,
  type: QuestionType.multiOption,
  options: [
    { value: FitAnswer.veryTight },
    { value: FitAnswer.tight },
    { value: FitAnswer.littleTight },
    { value: FitAnswer.normal },
    { value: FitAnswer.littleLoose },
    { value: FitAnswer.loose },
    { value: FitAnswer.veryLoose },
  ],
  required: true,
};

export const LengthQuestion: MultiOptionQuestion = {
  uid: DefaultQuestionUID.length,
  type: QuestionType.multiOption,
  options: [
    { value: LengthAnswer.veryShort },
    { value: LengthAnswer.short },
    { value: LengthAnswer.littleShort },
    { value: LengthAnswer.normal },
    { value: LengthAnswer.littleLong },
    { value: LengthAnswer.long },
    { value: LengthAnswer.veryLong },
  ],
  required: true,
  hidden: false,
};

export const BraSizeQuestion: MultiOptionQuestion = {
  uid: DefaultQuestionUID.braSize,
  type: QuestionType.multiOption,
  options: [
    { value: SizeAnswer.verySmall },
    { value: SizeAnswer.small },
    { value: SizeAnswer.littleSmall },
    { value: SizeAnswer.normal },
    { value: SizeAnswer.littleLarge },
    { value: SizeAnswer.large },
    { value: SizeAnswer.veryLarge },
  ],
  required: true,
  hidden: false,
};

export const PantySizeQuestion: MultiOptionQuestion = {
  uid: DefaultQuestionUID.pantySize,
  type: QuestionType.multiOption,
  options: [
    { value: SizeAnswer.verySmall },
    { value: SizeAnswer.small },
    { value: SizeAnswer.littleSmall },
    { value: SizeAnswer.normal },
    { value: SizeAnswer.littleLarge },
    { value: SizeAnswer.large },
    { value: SizeAnswer.veryLarge },
  ],
  required: true,
  hidden: false,
};

export const BraSupportQuestion: MultiOptionQuestion = {
  uid: DefaultQuestionUID.braSupport,
  type: QuestionType.multiOption,
  options: [
    { value: BraSupportAnswer.veryLow },
    { value: BraSupportAnswer.low },
    { value: BraSupportAnswer.littleLow },
    { value: BraSupportAnswer.medium },
    { value: BraSupportAnswer.littleHigh },
    { value: BraSupportAnswer.high },
    { value: BraSupportAnswer.veryHigh },
  ],
  required: true,
  hidden: false,
};

export const ComfortQuestion: MultiOptionQuestion = {
  uid: DefaultQuestionUID.comfort,
  type: QuestionType.multiOption,
  required: true,
  options: [
    { value: ComfortAnswer.veryLow },
    { value: ComfortAnswer.low },
    { value: ComfortAnswer.littleLow },
    { value: ComfortAnswer.medium },
    { value: ComfortAnswer.littleHigh },
    { value: ComfortAnswer.high },
    { value: ComfortAnswer.veryHigh },
  ],
};

export const SkinConcernsQuestion: MultiOptionQuestion = {
  uid: DefaultQuestionUID.skinConcerns,
  type: QuestionType.multiSelect,
  required: false,
  options: EnumToArrayValues(SkinConcernAnswer).map((value) => {
    return { value };
  }),
};

export function getDefaultQuestions(): Question[] {
  const usualSizeQuestion: DynamicSelectQuestion = {
    uid: DefaultQuestionUID.usualSize,
    type: QuestionType.dynamicSelect,
    required: true,
    contentCollection: QuestionDataSourceType.productSize,
  };

  const sizeQuestion: MultiOptionQuestion = {
    uid: DefaultQuestionUID.sizeLike,
    type: QuestionType.multiOption,
    options: [
      { value: SizeAnswer.verySmall },
      { value: SizeAnswer.small },
      { value: SizeAnswer.littleSmall },
      { value: SizeAnswer.normal },
      { value: SizeAnswer.littleLarge },
      { value: SizeAnswer.large },
      { value: SizeAnswer.veryLarge },
    ],
    required: true,
  };

  const fitLikeQuestion: MultiOptionQuestion = {
    uid: DefaultQuestionUID.fitLike,
    type: QuestionType.multiOption,
    options: [{ value: FitLikeAnswer.no }, { value: FitLikeAnswer.unsure }, { value: FitLikeAnswer.yes }],
    required: true,
    hidden: false,
  };

  const returnQuestion: MultiOptionQuestion = {
    uid: DefaultQuestionUID.return,
    type: QuestionType.multiOption,
    options: [{ value: ReturningAnswer.returning }, { value: ReturningAnswer.unsure }, { value: ReturningAnswer.keeping }],
    required: true,
    hidden: false,
  };

  const textQuestion: TextQuestion = {
    uid: DefaultQuestionUID.reviewText,
    type: QuestionType.text,
    required: false,
    hidden: false,
  };

  const ratingQuestion: TextQuestion = {
    uid: DefaultQuestionUID.rating,
    type: QuestionType.rating,
    required: false,
    hidden: true,
  };

  const braBandFitQuestion = {
    uid: DefaultQuestionUID.braBandFit,
    type: QuestionType.multiOption,
    options: [
      { value: FitAnswer.veryTight },
      { value: FitAnswer.tight },
      { value: FitAnswer.littleTight },
      { value: FitAnswer.normal },
      { value: FitAnswer.littleLoose },
      { value: FitAnswer.loose },
      { value: FitAnswer.veryLoose },
    ],
    required: true,
  };

  const braCupFitQuestion = {
    uid: DefaultQuestionUID.braCupFit,
    type: QuestionType.multiOption,
    options: [
      { value: FitAnswer.veryTight },
      { value: FitAnswer.tight },
      { value: FitAnswer.littleTight },
      { value: FitAnswer.normal },
      { value: FitAnswer.littleLoose },
      { value: FitAnswer.loose },
      { value: FitAnswer.veryLoose },
    ],
    required: true,
  };

  return [
    usualSizeQuestion,
    sizeQuestion,
    FitQuestion,
    LengthQuestion,
    BraSizeQuestion,
    braBandFitQuestion,
    braCupFitQuestion,
    BraSupportQuestion,
    PantySizeQuestion,
    ComfortQuestion,
    fitLikeQuestion,
    returnQuestion,
    SkinConcernsQuestion,
    ratingQuestion,
    textQuestion,
  ];
}
